import React from 'react'

function LayoutsMain2() {
  return (
    <div>LayoutsMain2</div>
  )
}

export default LayoutsMain2